import type { ReactNode } from "react";

import { ui } from "../lib/ui";
import { Info } from "./Info";

interface PanelProps {
  title: string;
  subtitle?: string;
  /** What this panel shows and how it is computed — the ⓘ tooltip. */
  about?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export function Panel({ title, subtitle, about, actions, children }: PanelProps) {
  return (
    <section className={`${ui.card} px-5 pb-5 pt-[18px]`}>
      <header className="mb-4 flex items-start justify-between gap-4">
        <div>
          <h2 className="m-0 flex items-center gap-2 text-base font-semibold">
            {title}
            {about && <Info text={about} />}
          </h2>
          {subtitle && <p className="mt-1 text-[13px] text-muted">{subtitle}</p>}
        </div>
        {actions}
      </header>
      {children}
    </section>
  );
}
